export const DOWNLOAD_APP_URL = 'https://dorian.app.link/KTCMD1A3Hsb';
